import React from "react";
import PropTypes from "prop-types";
import { BlockStack, Link, Text } from "@shopify/polaris";
import { Banner } from "lib/components";

const ShopifyEmbeddedSuccess = ({ cms }) => (
  <div className="embedded-view-toast">
    <Banner isOpen status="success" title={cms("common.shopifyEmbedded.title")}>
      <BlockStack gap="200">
        <Text as="p" variant="bodyMd">
          {cms("common.shopifyEmbedded.actionPrefix")}{" "}
          <Link url={cms("common.shopifyEmbedded.dashboardUrl")} external>
            {cms("common.shopifyEmbedded.linkText")}
          </Link>{" "}
          {cms("common.shopifyEmbedded.actionSuffix")}
        </Text>
      </BlockStack>
    </Banner>
  </div>
);

ShopifyEmbeddedSuccess.propTypes = {
  cms: PropTypes.func.isRequired,
};

export default ShopifyEmbeddedSuccess;
